import React from 'react'

export default function Videos() {
  return (
    <>
      <section className="container">
         <h1 className="intro w-50 mx-auto fs-2 text-center pt-5 intro">
          Nuestro contenido de Youtube
        </h1>
        <div className="row">

          <div className="col">




       
        <div className="text-center">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/5bai8RWTQn4"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>











          </div>
          <div className="col">






<iframe width="560" height="315" src="https://www.youtube.com/embed/euv2bKfgaYc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>









            
          </div>

        </div>
      </section>
    </>
  );
}
